
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/prism-anova",
      function () {
        return require("private-next-pages/features/prism-anova.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/prism-anova"])
      });
    }
  